import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelHeading from "../../components/panel/heading";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import RoleListTable from "../../components/users/roleListTable";
import { closeModal, openModal } from "../../state/modalSlice";
import CreateRoleModal from "../../modals/roles/createRole";
import { actions } from "../../state/reducer";
import { generateRandomString } from "../../utils";
import { useDispatch } from "react-redux";

const RoleListPage = () => {

  const dispatch = useDispatch();

  const handleOpenCreateModal = () => {
    dispatch(
      openModal({
        component: CreateRoleModal,
        context: {
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  }

  return (
    <PanelPage>
      <div className="panelColumn2">
        <div className="profileWidget">
          <div className="flex between">
            <PanelSubHeading text="Роли пользователей" />
            <div className="panelBtnContainer">
              <div className="btn panelActionBtn" onClick={handleOpenCreateModal}>+ Создать роль</div>
            </div>
          </div>
          <div className="flex between panelSearchContainer" />
          <RoleListTable search={""} />
        </div>
      </div>
    </PanelPage>
  );
};

export default RoleListPage;


